export default "__VITE_ASSET__CEbZJ$KW__"